import { z } from 'zod';
import { KbCategory, RecordId } from './schemas.ts';

// The shapes of the Library's calls for other modules (public.ts, ADR 0013, plan 2E).

/** By ids (up to an op's 20), or with no ids every entry, for a picker. */
export const EntriesInput = z.object({ ids: z.array(RecordId).max(20).nullable().default(null) });
export type EntriesInput = z.input<typeof EntriesInput>;

export const EntryTitle = z.object({ id: z.string(), title: z.string(), category: KbCategory });
export type EntryTitle = z.infer<typeof EntryTitle>;

export const EntriesResult = z.object({ entries: z.array(EntryTitle) });
export type EntriesResult = z.infer<typeof EntriesResult>;
